import { Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, FormHelperText, IconButton, Switch, TextField, Typography, useTheme } from '@mui/material'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import { toast } from 'react-toastify'
import { useEffect } from 'react'
import { useState } from 'react'
import React from 'react'
import * as Yup from 'yup'

import api from '../../service/api'
import { Icons } from '../../utils/utilities'

const defaultPermissions = {
    live_class_audit: false,
    study_material_audit: false,
    online_course: false,
    resume_builder: false,
    attendance_audit: false,
    exams: false,
    exam_audit: false,
    quizzes_audit: false,
    questionbanks_audit: false,
    feedback: false,
    api_settings: false,
    debug_user: false,
    analytics: false,
    recordings: false,
    assignment_audit: false,
    support: false,
    activity_log: false,
}
const allPermissions = {
    live_class_audit: true,
    study_material_audit: true,
    online_course: true,
    resume_builder: true,
    attendance_audit: true,
    exams: true,
    exam_audit: true,
    quizzes_audit: true,
    questionbanks_audit: true,
    feedback: true,
    api_settings: true,
    debug_user: true,
    analytics: true,
    recordings: true,
    assignment_audit: true,
    support: true,
    activity_log: true,
}
const controls = [
    { label: "Live Class Audit", permissionName: "live_class_audit" },
    { label: "Study Material Audit", permissionName: "study_material_audit" },
    { label: "Online Course", permissionName: "online_course" },
    { label: "Resume Builder", permissionName: "resume_builder" },
    { label: "Attendance Audit", permissionName: "attendance_audit" },
    { label: "Admission Exams", permissionName: "exams" },
    { label: "Exam Audit", permissionName: "exam_audit" },
    { label: "Assignment Audit", permissionName: "assignment_audit" },
    { label: "Quizzes Audit", permissionName: "quizzes_audit" },
    { label: "Question Banks Audit", permissionName: "questionbanks_audit" },
    { label: "feedback", permissionName: "feedback" },
    { label: "API settings", permissionName: "api_settings" },
    { label: "Debug User", permissionName: "debug_user" },
    { label: "Analytics", permissionName: "analytics" },
    { label: "Recordings", permissionName: "recordings" },
    { label: "Support and Tutorial", permissionName: "support" },
    { label: "Activity Log", permissionName: "activity_log" },
]

const AddEditAdmin = ( { setMode, mode, user } ) => {
    const [permissions, setPermissions] = useState( mode === "add" ? defaultPermissions : user.user_permissions || user.permissions )
    const [isIndeterminate, setIsIndeterminate] = useState( false )
    const [isAllChecked, setIsAllChecked] = useState( false )
    const [showPassword, setShowPassword] = useState( false )
    const [waiting, setWaiting] = useState( false )

    const { palette, border } = useTheme()


    const handleAllChange = ( e ) => {
        setIsAllChecked( e.target.checked )
        if ( e.target.checked ) {
            setPermissions( allPermissions )
        } else {
            setPermissions( defaultPermissions )
        }
    }

    const addNewAdmin = async ( values ) => {
        setWaiting( true )
        try {
            if ( values.password.trim() !== "" && values.password ) {
                const res = await api.createSubAdminAccount( { ...values, permissions } )
                toast( res.data.message )
                setMode( "manage" )
            }
        } catch ( err ) {
            console.log( err )
            toast( err?.response?.data?.message || "Something went wrong while adding new subadmin! please try again later" )
        } finally {
            setWaiting( false )
        }
    }

    const updateAdminUser = async ( values ) => {
        try {
            setWaiting( true )
            const res = await api.updateSubAdminAccount( { ...values, permissions }, user.user_id )
            toast( res.data.message )
        } catch ( err ) {
            console.log( err )
            toast( err?.response?.data?.message || "Something went wrong while updating new subadmin! please try again later" )
        } finally {
            setWaiting( false )
        }
    }

    const initialValues = {
        email: mode === "edit" ? user.user_email : "",
        username: mode === "edit" ? user.user_name : "",
        password: mode === "edit" ? "" : ""
    }

    const validationSchema = Yup.object().shape( {
        email: Yup.string().email( "Please provide valid email" ).required( "E-mail is required!" ),
        username: Yup.string().required( "Username is required!" ),
        password: Yup.string().test( "TEST FOR PASSWORD", "Provide a strong password.", ( val ) => {
            if ( mode === 'edit' ) return true
            return val?.match( `^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,32}$` )
        } )
    } )

    useEffect( () => {
        let previous = undefined
        let isDiff = false
        for ( const permission in permissions ) {
            if ( previous === true || previous === false ) {
                if ( previous !== permissions[permission] ) {
                    setIsIndeterminate( true )
                    isDiff = true
                    break
                }
            } else
                previous = permissions[permission]
        }
        if ( !isDiff ) {
            setIsIndeterminate( false )
            setIsAllChecked( previous )
        }
    }, [permissions] )

    return (
        <Box marginTop="20px" border="1px solid rgba(0,0,0,0.2)" padding="20px" borderRadius="5px">
            <Typography variant='h6' gutterBottom>Add new admin</Typography>
            <Formik onSubmit={mode === "add" ? addNewAdmin : updateAdminUser} initialValues={initialValues} validationSchema={validationSchema}>
                {() => (
                    // <Form autoComplete='off'>
                    //     <FormControl fullWidth sx={{ marginBottom: "10px", marginTop: "10px" }}>
                    //         <Field as={TextField} label="E-mail" name="email" variant='outlined' />
                    //         <FormHelperText sx={{ color: "error.main" }}> <ErrorMessage name="email" /> </FormHelperText>
                    //     </FormControl>
                    //     <FormControl fullWidth sx={{ marginBottom: "10px" }}>
                    //         <Field as={TextField} label="Username" type='text' name="username" variant='outlined' />
                    //         <FormHelperText sx={{ color: "error.main" }}> <ErrorMessage name="username" /> </FormHelperText>
                    //     </FormControl>
                    //     {mode === "add" && <FormControl fullWidth sx={{ marginBottom: "10px" }}>
                    //         <Field as={TextField} label="Password" type="password" name="password" variant='outlined' />
                    //         <FormHelperText sx={{ color: "error.main" }}> <ErrorMessage name="password" /> </FormHelperText>
                    //     </FormControl>}
                    //     <Box>
                    //         <Typography variant='subtitle2' color="secondary">Grant permissions</Typography>
                    //         <FormControlLabel label="All" control={<Checkbox checked={isAllChecked} onChange={handleAllChange} indeterminate={isIndeterminate} />} />
                    //         <Box marginLeft="20px" display="flex" flexDirection="column">
                    //             <FormControlLabel sx={{ "& span": { fontSize: "14px" } }} label="Live Class Audit" control={<Checkbox size='small' checked={permissions.live_class_audit} onChange={() => setPermissions( { ...permissions, live_class_audit: !permissions.live_class_audit } )} />} />
                    //             <FormControlLabel sx={{ "& span": { fontSize: "14px" } }} label="Study Material Audit" control={<Checkbox size='small' checked={permissions.study_material_audit} onChange={() => setPermissions( { ...permissions, study_material_audit: !permissions.study_material_audit } )} />} />
                    //             <FormControlLabel sx={{ "& span": { fontSize: "14px" } }} label="Online Course" control={<Checkbox size='small' checked={permissions.online_course} onChange={() => setPermissions( { ...permissions, online_course: !permissions.online_course } )} />} />
                    //             <FormControlLabel sx={{ "& span": { fontSize: "14px" } }} label="Resume Builder" control={<Checkbox size='small' checked={permissions.resume_builder} onChange={() => setPermissions( { ...permissions, resume_builder: !permissions.resume_builder } )} />} />
                    //             <FormControlLabel sx={{ "& span": { fontSize: "14px" } }} label="Attendance Audit" control={<Checkbox size='small' checked={permissions.attendance_audit} onChange={() => setPermissions( { ...permissions, attendance_audit: !permissions.attendance_audit } )} />} />
                    //             <FormControlLabel sx={{ "& span": { fontSize: "14px" } }} label="Admission Exams" control={<Checkbox size='small' checked={permissions.exams} onChange={() => setPermissions( { ...permissions, exams: !permissions.exams } )} />} />
                    //             <FormControlLabel sx={{ "& span": { fontSize: "14px" } }} label="Exam Audit" control={<Checkbox size='small' checked={permissions.exam_audit} onChange={() => setPermissions( { ...permissions, exam_audit: !permissions.exam_audit } )} />} />
                    //             <FormControlLabel sx={{ "& span": { fontSize: "14px" } }} label="Quizzes Audit" control={<Checkbox size='small' checked={permissions.quizzes_audit} onChange={() => setPermissions( { ...permissions, quizzes_audit: !permissions.quizzes_audit } )} />} />
                    //             <FormControlLabel sx={{ "& span": { fontSize: "14px" } }} label="Question Banks Audit" control={<Checkbox size='small' checked={permissions.questionbanks_audit} onChange={() => setPermissions( { ...permissions, questionbanks_audit: !permissions.questionbanks_audit } )} />} />
                    //             <FormControlLabel sx={{ "& span": { fontSize: "14px" } }} label="feedback" control={<Checkbox size='small' checked={permissions.feedback} onChange={() => setPermissions( { ...permissions, feedback: !permissions.feedback } )} />} />
                    //             <FormControlLabel sx={{ "& span": { fontSize: "14px" } }} label="API settings" control={<Checkbox size='small' checked={permissions.api_settings} onChange={() => setPermissions( { ...permissions, api_settings: !permissions.api_settings } )} />} />
                    //             <FormControlLabel sx={{ "& span": { fontSize: "14px" } }} label="Debug User" control={<Checkbox size='small' checked={permissions.debug_user} onChange={() => setPermissions( { ...permissions, debug_user: !permissions.debug_user } )} />} />
                    //             <FormControlLabel sx={{ "& span": { fontSize: "14px" } }} label="Analytics" control={<Checkbox size='small' checked={permissions.analytics} onChange={() => setPermissions( { ...permissions, analytics: !permissions.analytics } )} />} />
                    //             <FormControlLabel sx={{ "& span": { fontSize: "14px" } }} label="Recordings" control={<Checkbox size='small' checked={permissions.recordings} onChange={() => setPermissions( { ...permissions, recordings: !permissions.recordings } )} />} />
                    //         </Box>
                    //     </Box>
                    //     <Box display="flex" marginTop="20px" gap="10px">
                    //         <Button type='submit' variant='contained' disableElevation>{mode === "edit" ? "Update" : "Add admin"}</Button>
                    //         <Button onClick={() => { setMode( "manage" ); setPermissions( defaultPermissions ) }} color="error" variant='contained' disableElevation>Cancel</Button>
                    //     </Box>
                    // </Form>
                    <Form autoComplete='off'>
                        <FormControl fullWidth margin="normal">
                            <Typography variant='subtitle2' color={palette.form.label} >E-mail</Typography>
                            <Field id="admin-email-input" size="small" as={TextField} name="email" variant='outlined' />
                            <Typography variant='subtitle2' fontSize="12px" color="error.main" > <ErrorMessage name="email" /> </Typography>
                        </FormControl>
                        <FormControl fullWidth margin="normal">
                            <Typography variant='subtitle2' color={palette.form.label} >Username</Typography>
                            <Field id="admin-username-input" size="small" as={TextField} type='text' name="username" variant='outlined' />
                            <Typography variant='subtitle2' fontSize="12px" color="error.main" > <ErrorMessage name="username" /> </Typography>
                        </FormControl>
                        <FormControl fullWidth margin="normal">
                            <Typography variant='subtitle2' color={palette.form.label} >{mode !== 'add' ? "Set new password" : "Password"}</Typography>
                            <Field as={TextField} slotProps={{
                                input: {
                                    endAdornment: <IconButton onClick={() => setShowPassword( prev => !prev )}>
                                        {showPassword ? Icons.default.VisibilityOffIcon : Icons.default.VisibilityIcon}
                                    </IconButton>
                                }
                            }} id="admin-password-input" size="small" type={showPassword ? "text" : "password"} name="password" variant='outlined' />
                            <Typography variant='subtitle2' fontSize="12px" color="error.main" > <ErrorMessage name="password" /> </Typography>
                        </FormControl>
                        <Box marginTop="20px">
                            <Typography variant='subtitle2' color="secondary">Grant permissions</Typography>
                            <Box border={border[1]} borderRadius="10px" display="flex" flexDirection="column" bgcolor={palette.contentBg}>
                                <FormControlLabel label={<Typography component="span" fontSize="16px" pl="10px">Grant All Permissions</Typography>} labelPlacement='start' sx={{ justifyContent: "space-between", borderBottom: border[1], margin: "0", padding: "1px 5px" }} control={<Checkbox checked={isAllChecked} onChange={handleAllChange} indeterminate={isIndeterminate} />} />
                                <Box maxHeight="350px" padding="0 10px" overflow="auto" className="custom-scrollbar" display="flex" flexDirection="column">

                                    {controls.map( ctrl => (
                                        <FormControlLabel key={ctrl.label} label={<Typography component="span" fontSize="12px">{ctrl.label}</Typography>} sx={{ paddingY: "0", margin: "0", justifyContent: "space-between", padding: "1px 5px", borderBottom: border[1], borderWidth: "2px" }} labelPlacement='start' control={<Switch checked={permissions[ctrl.permissionName]} onChange={() => setPermissions( { ...permissions, [ctrl.permissionName]: !permissions[ctrl.permissionName] } )} />} />
                                    ) )}

                                </Box>
                            </Box>
                        </Box>
                        <Box display="flex" marginTop="20px" gap="10px">
                            <Button disabled={waiting} sx={{ textTransform: "capitalize" }} startIcon={waiting ? <CircularProgress size={14} /> : mode === "add" ? Icons.default.AddIcon : Icons.default.CheckCircleIcon} type='submit' variant='contained' disableElevation>{mode === "edit" ? waiting ? 'Updating...' : "Update" : waiting ? "Adding..." : "Add admin"}</Button>
                            <Button disabled={waiting} sx={{ textTransform: "capitalize" }} startIcon={Icons.default.CancelIcon} onClick={() => { setMode( "manage" ); setPermissions( defaultPermissions ) }} color="error" variant='outlined' disableElevation>Cancel</Button>
                        </Box>
                    </Form>
                )}
            </Formik>
        </Box>
    )
}

export default AddEditAdmin
